import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import IconArrow from "../../../assets/IconArrow";
import i18next from "i18next";
// Styles
import "../../../assets/saas/molecules/_inclusions_list.scss";
import IconCarInclusions from "../../../assets/IconCarInclusions";
import IconAllInclusive from "../../../assets/IconAllInclusive";
import { IconTravelInsurance } from "../../banners/iconsBannerSVG";
import InclusionListBlock from "../../commons/inclusionListblock";
import IconCheckCircle from "../../../assets/iconCheckCircle";
import { usePopoverInteraction } from "../../../hooks/usePopoverInteraction";
import PopoverComponent from "../../commons/PopoverComponent";
import DOMPurify from 'dompurify';
import BottomSheet from "../../commons/BottomSheet";
import IconHelpOutline from "presentation/assets/iconHelpOutline";
import IconNotIncludeCircle from "presentation/assets/iconNotIncludedCircle";
const RateQualifierSummary = ({ rateQualifier, generalDetails, applyDiscount, t, groupRate }) => {
    const today = new Date();
    const [isFirstVisible, setIsFirstVisible] = useState(true);
    const [isAnimating, setIsAnimating] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const optionsMonth = { month: "short" };
    const optionsDay = { day: "numeric" };
    const [showMore, setShowMore] = useState(false);
    // Get month and day separately
    const month = today.toLocaleDateString(i18next.language, optionsMonth);
    const day = today.toLocaleDateString(i18next.language, optionsDay);
    const ref = useRef(null);
    // make a function that changes how much elements are shown in the inclusion list the default being 4 and when the status of the new const is true show the rest of the elements
    // Custom hooks for responsive screen and popover interaction
    const { anchorEl, showPopover, showContextMenu, handleMouseEnter, handleMouseLeave, handleClickShowInformation, handleClosePopover, setShowContextMenu } = usePopoverInteraction();
    useEffect(() => {
        var _a;
        if (!isMounted)
            return;
        const parentElement = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.closest(".collection-list__item");
        if (parentElement && !isFirstVisible) {
            parentElement.classList.add("expanded");
        }
        else if (parentElement && isFirstVisible) {
            goToTopParentElement(parentElement, -120);
        }
    }, [isFirstVisible]);
    const changeVisibility = () => {
        setIsMounted(true);
        if (!isAnimating) {
            setIsAnimating(true);
            setTimeout(() => {
                setIsFirstVisible(!isFirstVisible);
                setIsAnimating(false);
            }, 300);
        }
    };
    let baseArray = [];
    let generalDetailsArray = [];
    // Construct the date string in the desired format
    const todayDate = ` ${month.charAt(0).toUpperCase()}${month.slice(1)} ${day}`;
    const goToTopParentElement = (parentElement, offset) => {
        if (parentElement) {
            parentElement.classList.remove("expanded");
            const elementPosition = parentElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition + offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
    if (rateQualifier.length < 2) {
        baseArray = [
            {
                name: t("summary_rq_1"),
                status: true, // Add status for the "true" case
                translate: [{
                        language: "EN",
                    },
                    {
                        language: "PT"
                    }
                ]
            },
            {
                name: t("summary_rq_2"),
                status: true, // Add status for the "true" case
                translate: [{
                        language: "EN",
                    },
                    {
                        language: "PT"
                    }
                ]
            },
            {
                name: t("summary_rq_3"),
                status: true, // Add status for the "true" case
                extraLabel: "Gratis",
                translate: [{
                        language: "EN",
                        extraLabel: "Free"
                    },
                    {
                        language: "PT",
                        extraLabel: "Gratuito"
                    }
                ]
            },
            {
                name: t("summary_rq_4"),
                status: true, // Add status for the "true" case
                translate: [{
                        language: "EN",
                    },
                    {
                        language: "PT"
                    }
                ]
            },
            {
                name: t("summary_rq_5"),
                status: true, // Add status for the "true" case
                extraLabel: "Gratis",
                translate: [{
                        language: "EN",
                        extraLabel: "Free"
                    },
                    {
                        language: "PT",
                        extraLabel: "Gratuito"
                    }
                ]
            },
            {
                name: t("summary_rq_6"),
                status: true, // Add status for the "true" case
                extraLabel: "Gratis",
                blockByIp: true,
                translate: [{
                        language: "EN",
                        extraLabel: "Free"
                    },
                    {
                        language: "PT",
                        extraLabel: "Gratuito"
                    }
                ]
            },
            ,
        ];
    }
    else {
        baseArray = rateQualifier;
    }
    if (generalDetails.length < 2) {
        generalDetailsArray = [
            {
                name: t("rq_5"),
                status: true,
                translate: [{
                        language: "EN",
                    },
                    {
                        language: "PT",
                    }
                ]
            },
            {
                name: t("rq_6"),
                status: true,
                translate: [{
                        language: "EN",
                    },
                    {
                        language: "PT",
                    }
                ]
            },
            {
                name: t("rq_7"),
                status: true,
                extraLabel: "Gratis",
                translate: [{
                        language: "EN",
                        extraLabel: "Free"
                    },
                    {
                        language: "PT",
                        extraLabel: "Gratuito"
                    }
                ]
            },
            {
                name: t("rq_8"),
                status: true,
            },
            {
                name: t("rq_3"),
                status: true,
            },
            {
                name: t("rq_9"),
                status: true,
            },
            {
                name: t("rq_2"),
                blockByIp: true,
                status: true,
            },
            {
                name: t("rq_10"),
                status: true,
            },
            {
                name: t("rq_11"),
                status: true,
            },
            {
                name: t("rq_12"),
                status: true,
            },
            {
                name: t("rq_4"),
                status: true,
            },
            {
                name: t("rq_13"),
                status: true,
            },
            {
                name: t("rq_14"),
                status: true,
            },
        ];
    }
    else {
        generalDetailsArray = generalDetails;
    }
    const slicedArray = !showMore ? baseArray : generalDetailsArray;
    const replaceCharacters = (str) => {
        // replace a variable in the string for a number
        return str.replace("{{number}}", (generalDetailsArray.length - baseArray.length).toString());
    };
    const [popoverValue, setPopoverValue] = useState(null);
    const [popoverTitle, setPopoverTitle] = useState(null);
    return (_jsxs(_Fragment, { children: [isFirstVisible ? (_jsx("ul", { ref: ref, className: `inclusion-list ${isAnimating ? "fade-out" : "fade-in"} ${isFirstVisible ? "" : "expanded"}`, children: slicedArray.map((value, index) => {
                    var _a, _b, _c;
                    return value.note &&
                        value.note !== "" &&
                        value.note != null ? (_jsxs(_Fragment, { children: [_jsxs("li", { className: value.blockByIp == true && !applyDiscount ? "hidden" : "inclusion-list__item", children: [_jsx("span", { className: "inclusion-icon", children: !value.unavailable ? _jsx(IconCheckCircle, {}) : _jsx(IconNotIncludeCircle, {}) }), _jsxs("div", { children: [_jsx("span", { className: "inclusion-text", children: i18next.language != "es" && value.translate.length > 1 ? (_a = value.translate.find((element) => element.language == i18next.language.toLocaleUpperCase())) === null || _a === void 0 ? void 0 : _a.name : value.name }), value.extraLabel &&
                                                _jsxs(_Fragment, { children: [_jsx("span", { className: "inclusion-text separator_symbol", children: "|" }), _jsx("span", { className: "inclusion-text--free", children: i18next.language != "es" && value.translate.length > 1 ? (_b = value.translate.find((element) => element.language == i18next.language.toLocaleUpperCase())) === null || _b === void 0 ? void 0 : _b.extraLabel : value.extraLabel })] })] })] }, index), _jsxs("li", { className: value.blockByIp == true && !applyDiscount ? "hidden" : "inclusion-list__item", children: [_jsx("span", { className: "inclusion-icon", children: "\u00A0" }), _jsx("span", { className: "inclusion-text text-promotion", children: value.note })] }, crypto.randomUUID())] })) : (_jsxs("li", { className: value.blockByIp == true && !applyDiscount ? "hidden" : "inclusion-list__item", children: [_jsx("span", { className: "inclusion-icon", children: !value.unavailable ? _jsx(IconCheckCircle, {}) : _jsx(IconNotIncludeCircle, {}) }), _jsx("div", { children: _jsxs("span", { className: "inclusion-text", children: [_jsx("span", { className: "inclusion-text", children: value.name }), value.toolTip && value.toolTip !== "" && value.toolTip != null && (_jsx("span", { className: "inclusion-help", onClick: (e) => { handleClickShowInformation(e, value.id); setPopoverValue(DOMPurify.sanitize(value.toolTip)); setPopoverTitle(value.toolTipTitle ? DOMPurify.sanitize(value.toolTipTitle) : ""); }, onMouseEnter: (e) => { handleMouseEnter(e, value.id); setPopoverValue(DOMPurify.sanitize(value.toolTip)); setPopoverTitle(value.toolTipTitle ? DOMPurify.sanitize(value.toolTipTitle) : ""); }, onMouseLeave: handleMouseLeave, children: _jsx(IconHelpOutline, {}) })), value.extraLabel &&
                                            _jsxs(_Fragment, { children: [_jsx("span", { className: "inclusion-text separator_symbol", children: "|" }), _jsx("span", { className: "inclusion-text--free", children: i18next.language != "es" && value.translate.length > 1 ? (_c = value.translate.find((element) => element.language == i18next.language.toLocaleUpperCase())) === null || _c === void 0 ? void 0 : _c.extraLabel : value.extraLabel })] })] }) })] }, index));
                }) })) : (_jsxs("ul", { ref: ref, className: `inclusion-list ${isAnimating ? "fade-out" : "fade-in"} ${isFirstVisible ? "" : "expanded"}`, children: [_jsx(InclusionListBlock, { iconTitle: _jsx(IconCarInclusions, {}), title: t("general_inclusions_1"), type: "1-insurance", generalDetails: generalDetails, applyDiscount: applyDiscount, hasBorderBottom: false }), _jsx(InclusionListBlock, { iconTitle: _jsx(IconAllInclusive, {}), title: t("general_inclusions_2"), type: "2-inclusions", generalDetails: generalDetails, applyDiscount: applyDiscount, hasBorderBottom: false }), _jsx(InclusionListBlock, { iconTitle: _jsx(IconTravelInsurance, {}), title: t("general_inclusions_3"), type: "3-asistence", generalDetails: generalDetails, applyDiscount: applyDiscount, hasBorderBottom: false, promoLabel: t("rq_4_1") + todayDate + ", 11:59pm" })] })), _jsxs("div", { className: "inclusion-list__item text-moreless", children: [_jsx("span", { className: "inclusion-icon" }), _jsx("span", { className: "inclusion-button", onClick: changeVisibility, children: !isFirstVisible ? (_jsxs("span", { className: "inclusion-button--less", children: [t("see_less"), " ", _jsx(IconArrow, {})] })) : (_jsxs("span", { className: "inclusion-button--more", children: [replaceCharacters(t("more_inclusions_button")), " ", _jsx(IconArrow, {})] })) })] }), _jsx(BottomSheet, { isVisible: showContextMenu, onClose: () => setShowContextMenu(false), children: popoverValue && inclusionMessageContent(popoverTitle ? popoverTitle : "", popoverValue) }), _jsx(PopoverComponent, { isVisible: showPopover, onClose: handleClosePopover, anchorEl: anchorEl, children: popoverValue && inclusionMessageContent(popoverTitle ? popoverTitle : "", popoverValue) })] }));
};
export default RateQualifierSummary;
const inclusionMessageContent = (title, content) => {
    return (_jsxs("div", { className: "inclusion-message-content", children: [_jsx("p", { className: "strong", dangerouslySetInnerHTML: { __html: title } }), _jsx("p", { dangerouslySetInnerHTML: { __html: content } })] }));
};
